import { call } from 'redux-saga/effects';
import * as Api from '../../../../services/fbm-api';
import { sagaRoutineRequest } from '../../../../helpers/saga';
import {
  fetchInventoryPackageOptions as fetchInventoryPackageOptionsRoutine,
  fetchInventoryItemLocationZoneOptions as fetchInventoryItemLocationZoneOptionsRoutine,
  fetchInventoryAvailabilityOptions as fetchInventoryAvailabilityOptionsRoutine
} from './routines';

export const fetchInventoryPackageOptions = () =>
  sagaRoutineRequest(fetchInventoryPackageOptionsRoutine, {
    request: () => call(Api.fetchInventoryPackageOptions)
  });

export const fetchInventoryItemLocationZoneOptions = () =>
  sagaRoutineRequest(fetchInventoryItemLocationZoneOptionsRoutine, {
    request: () => call(Api.fetchInventoryItemLocationZoneOptions)
  });

export const fetchInventoryAvailabilityOptions = () =>
  sagaRoutineRequest(fetchInventoryAvailabilityOptionsRoutine, {
    request: () => call(Api.fetchInventoryAvailabilityOptions)
  });
